import { render } from "./ModalSenhaAssinador.vue?vue&type=template&id=f6eb0eea&ts=true"
import script from "./ModalSenhaAssinador.vue?vue&type=script&lang=ts"
export * from "./ModalSenhaAssinador.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__